import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {Router} from '@angular/router';
import {MenuService} from '../../../services/menu.service';
import {ModuleService} from '../../../services/module.service';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-menu-add',
  templateUrl: './menu-add.component.html',
  styleUrls: ['./menu-add.component.scss']
})
export class MenuAddComponent implements OnInit{

  menuForm: FormGroup;
  modules: any[] = [];

  loading = this.translate.instant('Loading ...');

  public types: any[] = [
    {id: 1, name: 'sub', title: 'menu'}
  ];

  selectedBadgeTypes: string | undefined;

  public badgeTypes: any[] = [
    {id: 1, name: 'none😑'},
    {id: 2, name: 'light-primary'},
    {id: 3, name: 'light-secondary'},
  ];

  moduleSelected: number | undefined;
  categorySelected: number| string | undefined;

  saving = false;
  status = false;

  public data: any;

  isSubmitted = false;
  val: any | null;

  update = this.translate.instant('Update');
  create = this.translate.instant('Save');


  @ViewChild(DatatableComponent) table: DatatableComponent;
  changeDetectorRefs: ChangeDetectorRef[] = [];

  constructor(private fb: FormBuilder,
              private menuService: MenuService,
              private moduleService: ModuleService,
              private translate: TranslateService,
              private toastr: ToastrService,
              public activeModal: NgbActiveModal,
              public route: Router,
  ) {
    this.menuForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      icon: [''],
      type: ['', [Validators.required]],
      module: ['', [Validators.required]],
      position: null,
      badgeType: null,
      badgeValue: null,
      title: this.types[0]["title"],
      isEnable: '',
    });

  }

  ngOnInit(): void {
    this.menuForm.get('isEnable')?.setValue('1');
    console.log(this.menuForm);
    this.menuForm.patchValue(this.data);
    if (this.data){
      this.moduleSelected = this.data.module['@id'];
      this.categorySelected = this.data.category.id;
    }
    this.findAllModule();

    this.categorySelected = 'sub'

    console.log(this.status);
  }

  get fc(): any {
    return this.menuForm.controls;
  }

  changeVal(value: any): void{
    this.val = value;
    console.log(this.val);
  }

  checkType(event: any): void {
    console.log(event);
    const categoryName = event['name'];
    this.status = categoryName !== 'link';
  }

  onFormSubmit(): void{
    this.isSubmitted = true;
    if (this.menuForm.valid){
      this.saving = true;
      console.log(this.menuForm.value);


      this.menuForm.get('isEnable')?.setValue(this.menuForm.get('isEnable')?.value === '1');
      this.menuService.postMenu(this.menuForm.value).subscribe({
          next: (val: any) => {
            this.toastr.success('Menu create with success !', 'Success');
            this.activeModal.close();
          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {
            console.log(err);
            const errors: any[] = err.violations;

            if (errors){
              errors.forEach((v) =>
              {
                if (v.propertyPath === 'type'){
                  this.menuForm.get('type')?.setErrors({serverError: v.message});
                }
                if (v.propertyPath === 'module'){
                  this.menuForm.get('module')?.setErrors({serverError: v.message});
                }
                console.log(v.message);
                if (v.propertyPath === 'name'){
                  this.menuForm.get('name')?.setErrors({serverError: v.message});
                }

                this.saving = false;

              });
            }
            else {
              this.saving = false;
              this.toastr.error(err['hydra:title'], 'Error');
            }

            // this.menuForm.get('name')?.setErrors({serverError: err['hydra:description']});
            // this.saving = false;

          }
        });

    }
  }

  findAllModule(): any{
    this.moduleService.getEnableCollection().subscribe((data: any) => {
          this.modules = data['hydra:member'];
          this.modules = this.modules.map((v) => {
            v.id = v['@id'];
            console.log(v['@id']);
            return v;
          });
        },
        error => console.log(error)
    );
  }



}
